/* This code is not used any longer */

import React, { Component } from 'react';
import { Redirect } from 'react-router';
//import SweetAlert from "react-bootstrap-sweetalert";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import Icon from "../components/Selfcare/Common/Icon";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import Slider from "react-slick";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Version from "version";

//import "~slick-carousel/slick/slick.css";
//import "~slick-carousel/slick/slick-theme.css";

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";

import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import ReactGA from 'react-ga';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

class ChangeSumo extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeSumo", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            alert: null,
            redirect: null,
            toUrl: null,
            Packages: null,
            ChangeSumoDialogOpen: false,
            OrderSent: false,
            OrderError: '',
            OrderOpen: '',
            DisableButtons: false,
            buzy: false,
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            auth.signOut();
        }
        if (nextState.OrderSent && !this.state.OrderSent) {
            //setTimeout(
            //    function () {
            //        this.setState({
            //            alert: (
            //                <SweetAlert
            //                    success
            //                    style={{ display: "block", marginTop: "-150px", maxWidth: '100vw', left: 'auto', right: 'auto' }}
            //                    title="Takk!"
            //                    onConfirm={() => this.hideAlert()}
            //                    onCancel={() => this.hideAlert()}
            //                    confirmBtnCssClass={
            //                        this.props.classes.button + " " + this.props.classes.success
            //                    }
            //                    cancelBtnCssClass={
            //                        this.props.classes.button + " " + this.props.classes.success
            //                    }
            //                >
            //                    {this.state.EndOfMonth ? "Bestillingen er registrert, og vil tre i kraft i ved månedsskiftet." : "Bestillingen er registrert, og vil tre i kraft i løpet av 5-10 minutter."}
            //                </SweetAlert>
            //            )
            //        });
            //    }.bind(this),
            //    100
            //);
            this.dispatchState({ ServiceCancelled: false });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            //setTimeout(
            //    function () {
            //        this.setState({
            //            alert: (
            //                <SweetAlert
            //                    danger
            //                    style={{ display: "block", marginTop: "-150px", maxWidth: '100vw', left: 'auto', right: 'auto' }}
            //                    title="Bestilling feilet"
            //                    onConfirm={() => this.hideAlert()}
            //                    onCancel={() => this.hideAlert()}
            //                    confirmBtnCssClass={
            //                        this.props.classes.button + " " + this.props.classes.success
            //                    }
            //                    cancelBtnCssClass={
            //                        this.props.classes.button + " " + this.props.classes.success
            //                    }
            //                >
            //                    {this.state.OrderError}
            //                </SweetAlert>
            //            )
            //        });
            //    }.bind(this),
            //    100
            //);
        }
        if (nextState.OrderOpen && !this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: true });
                }.bind(this),
                100
            );
        }
        if (!nextState.OrderOpen && this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: false });
                }.bind(this),
                100
            );
        }

    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    handleConfirmChangeSumoDialogClose = () => {
        this.dispatchState({
            PerformChange: { SelectedServiceNo: this.state.SelectedPackage.ServiceNo, SelectedServiceName: this.state.SelectedPackage.Variant }
        });
        this.setState({ ChangeSumoDialogOpen: false, buzy: true });
    }
    handleChange = name => event => {
        this.dispatchState({ [name]: event.target.checked, ClearErrors: true });
    }

    handleChangeSumoDialogClose = () => {
        this.setState({ ChangeSumoDialogOpen: false, SelectedPackage: null, error: null });
    }

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    handleSelectPackage = selectedPackage => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Sumo package selected'
        });
        this.setState({ SelectedPackage: selectedPackage, ChangeSumoDialogOpen: true });

    };

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    render() {
        console.debug('ChangeSumo render');
        var settings = {
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 99999999,
                    settings: {
                        slidesToShow: 5,
                        infinite: this.state.Options && this.state.Options.length > 5 ? true : false,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4,
                        infinite: this.state.Options && this.state.Options.length > 4 ? true : false,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        infinite: this.state.Options && this.state.Options.length > 3 ? true : false,
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        infinite: this.state.Options && this.state.Options.length > 2 ? true : false,
                    } 
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        infinite: this.state.Options && this.state.Options.length > 1 ? true : false,
                    }
                }
                ],
        };

        const classes = this.props;
        const { t } = this.props;
        return (
            <div>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                <Dialog
                    open={this.state.ChangeSumoDialogOpen}
                    onClose={this.handleChangeSumoDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{t('selfcare:title.change-tv-2-sumo-packet')}</DialogTitle>
                    <DialogContent>
                        {t('selfcare:dialog.wish-to-change-packet', { 0: this.state.CurrentService ? this.state.CurrentService.Variant : null, 1: this.state.SelectedPackage ? this.state.SelectedPackage.Variant : null })}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmChangeSumoDialogClose} color="rose">
                            {t('selfcare:button.confirm-uc')}
                        </Button>
                        <Button onClick={this.handleChangeSumoDialogClose}>
                            {t('selfcare:button.cancel-uc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: this.state.AdministratedMsisdn }) }} /><br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { sessionStorage.stopAdmin = this.state.LoggedInMsisdn; this.navigateTo('/overview'); e.preventDefault(); }}>{t('selfcare:button.back-to-logged-in-user')}</a></div>}
                <Slide direction="down" in={this.state.show} mountOnEnter unmountOnExit>
                        <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                            <GridContainer justify="center">
                                <GridItem xs={10} >
                                    <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:title.change-tv-2-sumo-packet')}
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </Slide>
                <Slide direction="up" in={this.state.show} mountOnEnter unmountOnExit>
                            <form>
                        <GridContainer direction="row" justify="center" alignItems="center">
                            <GridItem xs={10} >
                                          <div>
                                                <Slider {...settings}>
                                                {this.state.Options ? this.state.Options.map((pack) => {
                                                    return (
                                                        <Card raised key={pack.ServiceNo}>
                                                            <CardBody>
                                                                <GridContainer justify="center">
                                                                <GridItem>                                                                
                                                                        <div style={{ fontSize: '22px', width: '200px', height: '70px', textAlign: 'center' }} className={classes.cardCategory}>{pack.Variant}</div>
                                                                </GridItem>
                                                                </GridContainer>
                                                                <div style={{ height: '180px', textAlign: 'left' }} className={classes.cardDescription} dangerouslySetInnerHTML={{ __html: pack.Description }}/>
                                                                <GridContainer direction="column" justify="center" alignItems="center">
                                                                    <GridItem>                                                                
                                                                        <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                                                            {pack.Fee}
                                                                        </h3>
                                                                    </GridItem>
                                                                    <GridItem>
                                                                        {pack.Ordered ? <Button round disabled>{t('selfcare:button.ordered')}</Button> : !pack.Current ? <Button round color="rose" disabled={this.state.DisableButtons || this.state.buzy} onClick={() => this.handleSelectPackage(pack)}>{t('selfcare:button.change-to')}</Button> : <Button round disabled>{t('selfcare:button.current')}</Button>}
                                                                    </GridItem>
                                                                </GridContainer>
                                                            </CardBody>
                                                        </Card>
                                                    )
                                                }) : null }
                                    </Slider>
                                    <GridContainer justify="center">
                                        <GridItem>
                                            <div style={{ paddingTop: '40px' }}>
                                                {this.state.buzy && <CircularProgress size={48} style={{
                                                    color: '#C2185B', position: 'absolute',
                                                    top: '20%',
                                                    left: '50%',
                                                    marginTop: -12,
                                                    marginLeft: -12,
                                                }} />}
                                                {this.state.OrderOpen && <div>Bestilling behandles</div>}
                                                <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                                            </div>
                                                        </GridItem>
                                        </GridContainer>

                                          </div>
                                    </GridItem>
                                </GridContainer>
                            </form>
                    </Slide>
            </div>
        );
    }
}
ChangeSumo.propTypes = {
};

export default compose(
    withStyles(pricingPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, ChangeSumo));

